<!--
 * @Author: 炽章
 * @Date: 2024-09-09 14:34:35
 * @LastEditors: 炽章
 * @LastEditTime: 2024-09-09 18:15:47
 * @FilePath: \src\components\LinAi\ai-robot-entry.vue
 * @Description: 小林ai入口
-->

<template>
  <div 
    v-if="isShowRobot && isCloseRobotDialog"
    ref="lsmyAiRobot"
    class="lsmy-ai-robot"
    @click="openRobot" 
    @mousedown="startDrag"
    @mouseup="stopDrag"
    :style="{ top: top + 'px' }">
    <img class="ai-robot-img" :src="require('@/assets/images/lsmy-ai-robot.png')">
    <img class="ai-robot-hide-img" :src="require('@/assets/images/lsmy-ai-robot-hide.png')">
    <span class="name">LinsyHome AI</span>
    <span class="tips">24小时在线咨询</span>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { getDict } from "@/utils/helpers";

export default {
  name: "ai-robot-entry",
  props: {},
  data() {
    return {
      isCloseRobotDialog: false,
      robotAuthDict: null,
      draggedItem: null,

      top: 0, // 元素的初始 top 值
      isDragging: false, // 是否正在拖拽
      startY: 0, // 拖拽起始位置的 Y 坐标
      hasDragged: false, // 记录是否发生了拖动
    }
  },
  computed: {
    // 用户工号及部门全路径id数组
    userNoAndDepartmentIdList() {
      const { no, fullId } = this.$store.state?.user?.userInfo || {}
      const list = fullId ? fullId.split(',') : []
      list.push(no)
      return list
    },
    // 是否展示小林ai机器人
    isShowRobot() {
      // 字典有值时判断用户是否在部门列表中， 无字典数据时全面放开
      return this.robotAuthDict && this.robotAuthDict.length
        ? this.robotAuthDict.some((item) => this.userNoAndDepartmentIdList.includes(item.code))
        : true;
    },
  },
  async created() {
    try {
      const dict = await getDict('AI_ROBOT_AUTH')
      this.robotAuthDict = dict
      // 没机器人权限时，弹窗及icon都不展示
      if (!this.isShowRobot) return;
      this.isCloseRobotDialog = true
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    // 初始化元素位置
    const recordTop = localStorage.getItem(`LINAI-TOP-${process.env.NODE_ENV}`) || 0
    console.log('recordTop: ', recordTop);
    this.top = isNaN(Number(recordTop)) || !recordTop ? window.innerHeight * 0.8 : Number(recordTop);
  },
  methods: {
    // 开始拖拽
    startDrag(event) {
      console.log('startDrag: ');
      event.preventDefault();
      this.isDragging = true;
      this.startY = event.clientY - this.top;

      // 监听 mousemove 和 mouseup 事件
      window.addEventListener("mousemove", this.onDrag);
      window.addEventListener("mouseup", this.stopDrag);
    },
    // 拖拽中
    onDrag(event) {
      console.log('onDrag: ');
      if (this.isDragging) {
        this.hasDragged = true
        // 计算新的 top 值
        const newTop = event.clientY - this.startY;

        // 限制拖拽范围（确保元素在页面内）
        const minTop = 0;
        const maxTop = window.innerHeight - this.$refs.lsmyAiRobot.offsetHeight;
        this.top = Math.max(minTop, Math.min(newTop, maxTop));
      }
    },
    // 结束拖拽
    stopDrag() {
      console.log('mouseup: ');
      this.isDragging = false;
      localStorage.setItem(`LINAI-TOP-${process.env.NODE_ENV}`, this.top)
      // 移除事件监听
      window.removeEventListener("mousemove", this.onDrag);
      window.removeEventListener("mouseup", this.stopDrag);
    },
    openRobot() {
      if (this.hasDragged) {
        this.hasDragged = false
        return
      }
      // const token = Cookies.get(process.env.VUE_APP_TOKEN_NAME) || ''
      // if (!token || (typeof token === 'string' && token.indexOf('undefined') > -1)) {
      //   this.$message.error('token不存在')
      //   return
      // }
      // window.open(`${location.protocol}${process.env.VUE_APP_ROBOT_PAGE_URL}/robotIndex?token=${token}&themeColor=PORTAL&appCode=LINSY-HOME`, '_blank')
      window.open('https://agent.linshimuye.com/chat/?app_id=ac7d511e-e7cc-44f5-a3ed-1a84204bbdae', "_blank");
    },

    async saveBuriedPoint({ businessType = '', businessId = '' }) {
      try {
        const params = {
          businessType,
          businessId
        }
        await this.$axios.post(
          `/${process.env.VUE_APP_PROXY_DING_OA}/buriedPoint/saveBuriedPoint`,
          params,
          { type: "form", uselsmyAccount: true }
        );
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lsmy-ai-robot {
  width: 302px;
  height: 159px;
  position: fixed;
  right: -220px;
  bottom: 40px;
  padding-left: 30px;
  cursor: pointer;
  z-index: 999;
  user-select: none;
  img {
    display: block;
    // width: 257px;
  }
  .ai-robot-img {
    display: none;
  }
  .ai-robot-hide-img {
    width: 85px;
    position: relative;
    left: 0;
    right: 0;
    top: 50%;
    margin-top: -47px;
    transform: rotate(-32deg);
  }
  &:hover {
    transition: right ease 0.3s;
    // transform: rotate(0deg);
    right: 0;
    .ai-robot-img {
      display: block;
    }
    .ai-robot-hide-img {
      display: none;
    }
  }
  span {
    display: inline-block;
    color: #333;
    position: absolute;
  }
  .name {
    font-size: 18px;
    font-weight: bold;
    line-height: 27px;
    left: 125px;
    top: 69px;
  }
  .tips {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    top: 96px;
    left: 125px;
  }
}
</style>
